import { render, staticRenderFns } from "./ItemSpread.vue?vue&type=template&id=0b788a84"
import script from "./ItemSpread.vue?vue&type=script&lang=js"
export * from "./ItemSpread.vue?vue&type=script&lang=js"
import style0 from "./ItemSpread.vue?vue&type=style&index=0&id=0b788a84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports